import React from "react"

type CalendarHeaderTitleProps = {
	title: string
}

const CalendarHeaderTitle = (props: CalendarHeaderTitleProps) => {
	const { title } = props

	return <div className="multi-calendar-range__header-title">{title}</div>
}

export default CalendarHeaderTitle
